import React, { type ReactElement } from 'react';
import NoMatchIcon from './Icons/NoMatchIcon';
import NeutralIcon from './Icons/NeutralIcon';
import MatchIcon from './Icons/MatchIcon';
import NoIcon from './Icons/NoIcon';
import {
  STATUS_CERTIFIED,
  STATUS_CUSTOM,
  STATUS_MATCH,
  STATUS_NEUTRAL,
  STATUS_NO_MATCH,
} from '../../../../../constants/roleRequirementStatus';
import { IconCertifiedWithIntercom } from 'src/App/AppPageBlock/QuestionnaireSubmission';
import { Box } from 'braid-design-system';

interface Props {
  children: ReactElement;
}

const nonBraidMarginTopOffSet = { marginTop: 1 };

const NonBraidIconAlignment = ({ children }: Props) => (
  <Box style={nonBraidMarginTopOffSet}>{children}</Box>
);

const ICON_MAPPING: Record<string, () => ReactElement> = {
  [STATUS_CUSTOM]: () => <NoIcon />,
  [STATUS_CERTIFIED]: () => <IconCertifiedWithIntercom />,
  [STATUS_NO_MATCH]: () => (
    <NonBraidIconAlignment>
      <NoMatchIcon />
    </NonBraidIconAlignment>
  ),
  [STATUS_NEUTRAL]: () => (
    <NonBraidIconAlignment>
      <NeutralIcon />
    </NonBraidIconAlignment>
  ),
  [STATUS_MATCH]: () => <MatchIcon />,
};

const RoleRequirementIcon = ({ status }: { status: string }) => {
  const icon = ICON_MAPPING[status] || (() => <></>);
  return icon();
};

export default RoleRequirementIcon;
